var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
import { Navigate } from 'react-router-dom';
import { useAuthProvider } from '#context';
export const ManagementPlatformRoute = ({ children, }) => {
    _react_refresh_temp_2();
    const { currentUser } = useAuthProvider();
    if (currentUser?.partnerOrganizations &&
        currentUser.partnerOrganizations.length > 0) {
        return children;
    }
    return _jsx(Navigate, { to: "/workspaces" });
};
_react_refresh_temp_1 = ManagementPlatformRoute;
$RefreshReg$(_react_refresh_temp_1, "ManagementPlatformRoute");
_react_refresh_temp_2(ManagementPlatformRoute, "b0WOwRgVIKrHfkYSRIu+XLATATo=", false, () => [useAuthProvider]);
